import * as yup from 'yup';

export const schema = yup.object({
  dateFrom: yup.mixed().nullable().required('Укажите дату начала').default(null),
  dateTo: yup
    .mixed()
    .nullable()
    .required('Укажите дату окончания')
    .default(null)
    .test('date-range', 'Дата окончания не может быть раньше даты начала', function validateDateRange(value) {
      const { dateFrom } = this.parent;

      if (!dateFrom || !value) {
        return true;
      }

      return new Date(value).getTime() >= new Date(dateFrom).getTime();
    }),
});
